import React from "react";
import "./style.scss";

const CardContent = (props) => {
  return (
    <div className="content-wrapper" onClick={props.onClick}>
      <div className="img-wrapper">
        <img src={props.image} alt="logo_image" />
      </div>
      <div className="desc-wrapper">
        <h5>{props.name}</h5>
        <div className="desc-box">
          <span
            className="desc"
            dangerouslySetInnerHTML={{ __html: `${props.description}` }}
          />
        </div>
        <div className="icon-wrapper">
          <img src={props.logoLike} alt="logo_image" />
          <span className="like-count">{props.countLike}</span>
        </div>
      </div>
    </div>
  );
};

export default CardContent;
